import { useEffect } from 'react'

const FIELD_ID_PREFIX = 'af-field-'
export const getFieldId = (id: string) => `${FIELD_ID_PREFIX}${id}`

const scrollToFieldId = (fieldId: string) => {
  const el = document.getElementById(getFieldId(fieldId))
  if (!el) {
    return
  }
  el.scrollIntoView({ block: 'start', behavior: 'smooth' })
  el.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus({ preventScroll: true })
}

type UseScrollToFirstErrorParams = {
  submitCount: number
  errors: Record<string, unknown>
  orderedFieldIds: readonly string[]
}

export const useScrollToFirstError = ({
  submitCount,
  errors,
  orderedFieldIds,
}: UseScrollToFirstErrorParams) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: only re-scroll when submit is attempted, not on every error change
  useEffect(() => {
    if (submitCount === 0) {
      return
    }
    const firstErroredId = orderedFieldIds.find(id => errors[id] !== undefined)
    if (firstErroredId) {
      scrollToFieldId(firstErroredId)
    }
  }, [submitCount])
}
